import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";  
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 

const EditItemPropertyType = ({ show, onClose , propertyTypeId, onUpdated }) => {
 
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');  

    // Helper function to convert string to Title Case while preserving spaces
    const toTitleCase = (str) => {
        return str
          .toLowerCase()
          .split(/(\s+)/) // split by spaces but keep spaces in array
          .map(word => {
            if (word.trim() === '') return word; // preserve spaces
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join('');
    };

    // Fetch the current department data when the modal is opened
    useEffect(() => {
        if (show && propertyTypeId) {
            axios.get(`${baseURL}/propertytype/${propertyTypeId}`)
                .then(response => {
                    const { propertytype_name, description } = response.data.data;
                    setName(propertytype_name || '');
                    setDescription(description || ''); 
                    setErrors({});
                    setNameLengthError('');
                    setDescLengthError('');
                })
                .catch(error => {
                    console.error("Error fetching propertytype:", error);
                });
        }
    }, [show, propertyTypeId]);

    const handleNameChange = (e) => {
        let value = e.target.value || '';
        value = toTitleCase(value);
        setName(value);

        if (value.length <= 300) {
            setNameLengthError('');
        }

        // Clear server-side errors on change
        setErrors(prev => ({ ...prev, propertytype_name: '' }));
    };

    const handleDescriptionChange = (e) => {
        let value = e.target.value || '';
        value = toTitleCase(value);
        setDescription(value);

        if (value.length <= 500) {
            setDescLengthError('');
        }

        // Clear server-side errors on change
        setErrors(prev => ({ ...prev, description: '' }));
    };

    const handleSubmit = () => {
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');

        const safeName = name ?? '';
        const safeDescription = description ?? '';

        if (safeName.trim().length === 0) {
            setErrors(prev => ({
                ...prev,
                propertytype_name: "This field is required"
            }));
            return;
        }

        if (safeName.length > 300) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }

        if (safeDescription.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }

        axios.put(`${baseURL}/propertytype/${propertyTypeId}`, {
            propertytype_name: safeName,
            description: safeDescription,
        })
        .then(response => {
            onClose();
            if (onUpdated) onUpdated();
            toast.success("Property Type Updated successfully!");
        })
        .catch(error => {
            if (error.response?.status === 400 && error.response.data.errors) {
                setErrors(error.response.data.errors);
            } else {
                console.error("Update failed:", error);
                toast.error("Update Failed");
            }
        });
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Property Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
               <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Property Type<span className="required">*</span></label>
                            <input type="text"
                            className={`form-control ${errors.propertytype_name ? 'is-invalid' : ''}`}
                             placeholder="Enter Temperature" 
                               value={name}
                                onChange={handleNameChange}/>
                                 {errors.propertytype_name && (
                                <div className="invalid-feedback">{errors.propertytype_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}   />
                                {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Property Type  <i className="fas fa-angle-double-right ms-2"></i></Link> */}
                         <Button variant="primary" size="sm" onClick={handleSubmit}>Update Property Type  <i className="fas fa-angle-double-right ms-2"></i></Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditItemPropertyType;
